
export interface TBDChatType{
    timestamp: Date;
    lines: string;

}
//https://odinsrazor.tumblr.com/  but the password has changed.
export const precoffinChats:TBDChatType[] = [];


precoffinChats.push({timestamp: new Date(1995, 8,12,14,3 ),lines: `troveTextravaganza: wanda could I get you to sign off on this marketing copy?
CEBro: DEPENDS
CEBro: DID IT COME FROM THE CLOSER
troveTextravaganza: of couuuuurse it came from her
troveTextravaganza: what do you take me for
CEBro: OKAY HIT ME
troveTextravaganza: "From the makers of the classic retro game, Zampanio, comes gameplay like you've never seen before. Activate trap cards and more with the new Zampanio: The Trading Card Game! It's time to Duel!" 
CEBro: LOLOLOLOLOL
CEBro: PERFECT
CEBro: THERES NO WAY ANYONE ELSE FROM THE FUTURE WON'T NOTICE ITS A BLATANT RIP OFF
CEBro: CAN'T WAIT TO SEE THEIR REACTIONS`});

precoffinChats.push({timestamp: new Date(1995, 8,12,14,3 ),lines: `troveTextravaganza: wanda
troveTextravaganza: whhhhhhhhhhhy am i seeing that we've gotten yet another lawsuit???
CEBro:  LOOK 
CEBro: ITS NOT MY FAULT THAT PERFECT FUTURE KNOWLEDGE LOOKS SUSPICIOUSLY LIKE INSIDER TRADING
troveTextravaganza: we have an entire game company!!
troveTextravaganza: we could just make money the NORMAL way!!
troveTextravaganza: why do you have to keep cheating at the stock market??
CEBro:  LOL
CEBro:  DO YOU KNOW HOW TO MAKE A GAME
troveTextravaganza: when has THAT ever stopped us
troveTextravaganza: at least when you steal games from the future
troveTextravaganza: no one can tell that you're being an asshole
CEBro: DON'T WORRY ABOUT IT
CEBro: WHATS THE WORST THAT COULD HAPPEN
troveTextravaganza: are you freaking kidding me, wanda!?
troveTextravaganza: every time someone digs into our financial records
troveTextravaganza: I'M the one that has to figure out how to keep them from 
troveTextravaganza: going all obsessive spiraly locked in a hell maze of their own creation
CEBro: AND THATS WHY YOURE THE BEST CHIEF FINANICIAL BRO-CIFER.
troveTextravaganza: never call me that again
troveTextravaganza: ahsfj
troveTextravaganza: fine
troveTextravaganza: but I'm reaching out for outside counsel this time
CEBro: SURE THING BRO
CEBro: ITS NOT LIKE WE CAN'T AFFORD IT`});

